import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "@/store"
import { openCalendar, selectionIsStale } from "../bookingCalendarSlice"
import { SITE_TIME_ZONE, todayInZone } from "./siteTime"

/**
 * Opens the calendar on today's Pacific date when the selection it would otherwise show was made on
 * an earlier day (AB#821) — a tab left open past midnight. Returns false until that has happened, so
 * the caller draws nothing for the stale day rather than fetching it and then the right one.
 *
 * Decided once, on mount: a calendar already open when midnight passes stays on the day it shows
 * until the user moves, and "Go to today" (enabled again, since the day shown is no longer today)
 * takes them to the new one.
 */
export function useOpenOnToday(): boolean {
  const dispatch = useAppDispatch()
  const todayWhenOpened = useAppSelector(state => state.bookingCalendar.todayWhenOpened)

  const [stale, setStale] = useState(() => selectionIsStale({ todayWhenOpened }, todayInZone(SITE_TIME_ZONE)))

  useEffect(() => {
    if (!stale) return
    dispatch(openCalendar(todayInZone(SITE_TIME_ZONE)))
    setStale(false)
  }, [stale, dispatch])

  return !stale
}
